export default __webpack_public_path__ + "static/media/LeftArrow.571c2747.svg";